import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة فرق الطول بين شخصين";
const DESCRIPTION =
  "احسب فرق الطول بين شخصين باستخدام هذه الحاسبة السهلة. تساعدك هذه الأداة في معرفة الفرق الدقيق في الطول بين شخصين عند إدخال أطوالهم.";
const KEYWORDS = "حاسبة, فرق الطول, شخصين, مقارنة, طول, ارتفاع";
const OG_URL =
  "https://do-calculate.com/calculator/ar/height-difference-calculator/";
function HeightDifferenceCalculator() {
  const [heightPerson1, setHeightPerson1] = useState("0");
  const [heightPerson2, setHeightPerson2] = useState("0");
  const [heightDifference, setHeightDifference] = useState(null);
  const [error, setError] = useState("");
  const calculateHeightDifference = () => {
    try {
      if (heightPerson1 === "0" && heightPerson2 === "0") {
        setError("الرجاء إدخال أطوال صحيحة لحساب الفرق");
        return;
      }
      const difference = Math.abs(heightPerson1 - heightPerson2);
      setHeightDifference(difference);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  توفر هذه الحاسبة وسيلة بسيطة لمعرفة الفرق في الطول بين شخصين.
                  سواء كنت تريد مقارنة طولك بطول صديقك أو أحد أفراد عائلتك، يمكن
                  لهذه الأداة مساعدتك في الحصول على الإجابة بسرعة وسهولة. يعتمد
                  الفرق في الطول على إدخال أطوال الشخصين اللذين ترغب في مقارنة
                  طولهما. هذه الأداة مفيدة في العديد من السيناريوهات، مثل مقارنة
                  طول الأطفال مع الآباء أو حتى لمجرد الفضول.
                </p>
                <p>
                  على سبيل المثال، إذا كنت ترغب في معرفة الفرق في الطول بين شخص
                  يبلغ طوله 180 سم وآخر يبلغ طوله 170 سم، يمكنك استخدام هذه
                  الحاسبة لتحديد الفرق بدقة. يتم حساب الفرق ببساطة من خلال طرح
                  الطول الأصغر من الطول الأكبر. هذه المعلومات قد تكون مفيدة عند
                  اختيار الملابس أو عند شراء أحذية بكعب عالٍ، حيث يمكن للفرق في
                  الطول أن يؤثر على اختيارك.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="1st-Input">طول الشخص الأول:</label>
                    <input
                      id="1st-Input"
                      type="number"
                      value={heightPerson1}
                      onChange={(e) => setHeightPerson1(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text ">سم</span>
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="2nd-Input">طول الشخص الثاني:</label>
                    <input
                      id="2nd-Input"
                      type="number"
                      value={heightPerson2}
                      onChange={(e) => setHeightPerson2(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text ">سم</span>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateHeightDifference}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  heightDifference !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>فرق الطول: {heightDifference.toFixed(2)} سم</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كيفية حساب فرق الطول بين شخصين
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 1: تحديد طول الشخص الأول
                    </h2>
                  </u>
                  <p>
                    في البداية، تحتاج إلى معرفة طول الشخص الأول الذي ترغب في
                    حساب الفرق في الطول معه. يجب أن يكون الطول مقاسًا
                    بالسنتيمترات (سم) لسهولة الحساب. قد يكون هذا الشخص هو أنت أو
                    أي شخص آخر ترغب في مقارنة طوله بشخص آخر. تأكد من قياس الطول
                    بدقة، حيث إن القيم الصحيحة ستساعدك في الحصول على نتائج دقيقة
                    وموثوقة.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 2: تحديد طول الشخص الثاني
                    </h2>
                  </u>
                  <p>
                    بعد تحديد طول الشخص الأول، الخطوة التالية هي معرفة طول الشخص
                    الثاني. مرة أخرى، تأكد من أن الطول مقاس بالسنتيمترات (سم).
                    يمكن أن يكون الشخص الثاني هو صديق، أحد أفراد العائلة، أو حتى
                    شخصية مشهورة ترغب في معرفة الفرق في الطول بينها وبينك. إدخال
                    الطول بدقة سيساعد في الحصول على حسابات دقيقة للفرق في الطول.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 3: حساب فرق الطول
                    </h2>
                  </u>
                  <p>
                    بعد إدخال أطوال الشخصين، يمكنك حساب الفرق بينهما بسهولة.
                    لحساب فرق الطول، كل ما عليك فعله هو طرح الطول الأصغر من
                    الطول الأكبر. هذه العملية الحسابية البسيطة ستعطيك الفرق
                    الدقيق في الطول بين الشخصين. إذا كانت النتيجة صفرًا، فهذا
                    يعني أن الشخصين متساويان في الطول. أما إذا كانت النتيجة
                    موجبة أو سالبة، فستعرف من الأطول.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كان طول الشخص الأول 180 سم وطول الشخص الثاني 170
                    سم، فإن فرق الطول هو 10 سم.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: استخدام فرق الطول في الحياة اليومية
                    </h2>
                  </u>
                  <p>
                    بعد حساب فرق الطول، يمكن أن يكون لهذه المعلومات تطبيقات
                    متعددة في الحياة اليومية. على سبيل المثال، عند شراء الملابس،
                    يمكن أن يكون فرق الطول بين شخصين مؤشرًا جيدًا لاختيار الحجم
                    المناسب. كما يمكن أن يساعدك في التخطيط للأحداث التي تتطلب
                    ترتيب الأشخاص حسب الطول، مثل التصوير الجماعي أو المناسبات
                    الرسمية. فهم فرق الطول يمكن أن يساعدك أيضًا في تعزيز التفاعل
                    الاجتماعي، حيث يمكنك استخدام هذه المعلومات في محادثاتك
                    اليومية.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كنت أنت وأحد أصدقائك تخططان لشراء نفس النوع من
                    الملابس، قد يساعدك فرق الطول في اختيار المقاسات المناسبة.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default HeightDifferenceCalculator;
